module.exports = __webpack_public_path__ + "static/img/avatar.1254ad7f.png";